var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authentication-object-icon-table-cell"},[_c('div',{staticClass:"authentication-object-icon-table-cell__icon"},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }